import { Button, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "#f5f7ff",
        padding: 2,
      }}
    >
      <Typography variant="h3" fontWeight={600} gutterBottom>
        404
      </Typography>

      <Typography variant="h6" mb={2}>
        Page not found
      </Typography>

      <Typography variant="body1" color="text.secondary" mb={3}>
        The page you are looking for does not exist.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/adminstrator-page")}
      >
        Go Back to Home
      </Button>
    </Box>
  );
};

export default PageNotFound;
